import React from 'react';
import { SignIn as ClerkSignIn } from '@/integrations/clerk';
import { useNavigate } from 'react-router-dom';

/**
 * SignInPage - Keyword OS Sign In Page
 * 
 * Features:
 * - Clerk SignIn component integration
 * - Redirects to /app/dashboard after successful sign in (consistent with proper UX flow)
 * - Matches Keyword OS design system
 */
const SignInPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Sign in to Keyword OS
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Access your keyword research dashboard
          </p>
        </div>

        {/* Clerk Sign In Component */}
        <div className="mt-8">
          <ClerkSignIn 
            afterSignInUrl="/app/dashboard"
            redirectUrl="/app/dashboard"
            appearance={{
              elements: {
                rootBox: "mx-auto",
                card: "shadow-lg border border-gray-200 rounded-lg p-6",
                headerTitle: "hidden", // Hide default title since we have our own
                socialButtonsBlockButton: "w-full justify-center border border-gray-300 rounded-md px-4 py-2 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                formButtonPrimary: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                formFieldInput: "appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm",
                footerActionLink: "text-indigo-600 hover:text-indigo-500"
              }
            }}
          />
        </div>

        {/* Footer Link to Sign Up */}
        <div className="text-center">
          <p className="text-sm text-gray-600">
            Don't have an account?{' '}
            <button
              onClick={() => navigate('/auth/sign-up')}
              className="font-medium text-indigo-600 hover:text-indigo-500 underline"
            >
              Sign up here
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;